import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { getUserConversations, pushSingleMessage, updateUserConversationPreferences, updateUnreadMessagesQuantity,
  startConversation } from '../../../actions/conversations';
import { clearWorkersPredictionsList, searchWorkersAction } from '../../../actions/users';
import { extractConversations } from '../../../helpers/conversations';
import { addVisibilityListener, removeVisibilityListener,
  subscribeToVisibilityChange, unsubscribeFromVisibilityChange } from '../../../helpers/handleDocumentVisibility';
import ConversationsList from './ConversationsList';
import { CONVERSATIONS_LIST_PAGE_SIZE } from '../../../constants/general';
import PaginationBaseComponent from '../../common/PaginationBaseComponent';
import notificationHOC from './notificationHOC';

class ConversationsListContainer extends PaginationBaseComponent {
  static propTypes = {
    user: PropTypes.object.isRequired,
    conversations: PropTypes.array.isRequired,
    pagesQuantity: PropTypes.number.isRequired,
    convIdfromNotification: PropTypes.number,
    isLoading: PropTypes.bool.isRequired,
    getDataAction: PropTypes.func.isRequired,
    pushSingleMessage: PropTypes.func.isRequired,
    updateUserConversationPreferences: PropTypes.func.isRequired,
    updateUnreadMessagesQuantity: PropTypes.func.isRequired,
    startConversation: PropTypes.func.isRequired,
    searchWorkersAction: PropTypes.func.isRequired,
    clearWorkersPredictionsList: PropTypes.func.isRequired,
    workersPredictionsList: PropTypes.array.isRequired
  };

  constructor (props) {
    super(props);
    this.pageSize = CONVERSATIONS_LIST_PAGE_SIZE;
    this.state = {
      activePage: this.getActivePage(),
      goToPageBtnIsShown: false
    };
    this.convIdfromNotification = props.convIdfromNotification;
  }

  componentDidMount () {
    this.loadData();
    subscribeToVisibilityChange(this.props.getDataAction);
    addVisibilityListener();
  }

  componentWillUnmount () {
    unsubscribeFromVisibilityChange(this.props.getDataAction);
    removeVisibilityListener();
  }

  addAdminLastMessageToList = message => {
    this.props.pushSingleMessage(message);
  };

  updateConversationMessagesCount = async (conversation_id, participant_id) => {
    const { updateUserConversationPreferences, updateUnreadMessagesQuantity } = this.props;
    await updateUserConversationPreferences(
      conversation_id,
      participant_id,
      {
        unread_count: 0
      }
    );
    return updateUnreadMessagesQuantity();
  };

  render () {
    const { conversations, isLoading, match: { path }, pagesQuantity, searchWorkersAction, workersPredictionsList,
      clearWorkersPredictionsList, startConversation, user } = this.props;
    return (
      <React.Fragment>
        <ConversationsList
          conversations={conversations}
          isLoading={isLoading}
          addAdminLastMessageToList={this.addAdminLastMessageToList}
          updateConversationMessagesCount={this.updateConversationMessagesCount}
          path={path}
          convIdfromNotification={this.convIdfromNotification}
          searchWorkersAction={searchWorkersAction}
          clearWorkersPredictionsList={clearWorkersPredictionsList}
          workersPredictionsList={workersPredictionsList}
          startConversation={startConversation}
          user={user}
        />
        { pagesQuantity > 1 && this.renderPagination() }
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    conversations: extractConversations(state),
    pagesQuantity: state.conversations.pagesQuantity,
    isLoading: state.conversations.isLoading,
    workersPredictionsList: state.users.workersPredictionsList
  };
};

const mapDispatchToProps = {
  getDataAction: getUserConversations,
  pushSingleMessage,
  updateUserConversationPreferences,
  updateUnreadMessagesQuantity,
  searchWorkersAction,
  clearWorkersPredictionsList,
  startConversation
};

export default compose(connect(mapStateToProps, mapDispatchToProps), notificationHOC)(ConversationsListContainer);



// WEBPACK FOOTER //
// ./src/components/app/messages/ConversationsListContainer.js